import { useMemo } from 'react';
import { convertFieldValueAvroToJson } from 'rpc-client-utils';
import { skipToken, useResource, useResourceActions } from 'pulse/react';
import { GetTicketDetailsRpc } from '../../__generated__/chirp/com/hubspot/support/portal/rpc/TicketsRpc.resources';
import { useRefetchOnWindowFocus } from '../utils/useRefetchOnWindowFocus';
import { getIsPreview } from '../utils/isPreview';
import { getPreviewTicket } from './previewMocks';
import { getPortalAccountId, getPortalInstanceId } from 'portals-platform-lib';
export const getTicketDetailsParams = ticketId => ({
  accountId: getPortalAccountId(),
  portalInstanceId: getPortalInstanceId(),
  params: {
    ticketId
  }
});
export const useTicket = id => {
  const {
    isPreview
  } = getIsPreview();
  const params = getTicketDetailsParams(id);
  const {
    data,
    loading,
    error
  } = useResource(GetTicketDetailsRpc, {
    params: !id || isPreview ? skipToken : params
  });
  const {
    invalidate
  } = useResourceActions(GetTicketDetailsRpc, {
    params
  });
  useRefetchOnWindowFocus({
    refetch: invalidate,
    loading
  });
  const ticket = useMemo(() => {
    if (isPreview && id) {
      return getPreviewTicket(id);
    }
    if (!data) {
      return undefined;
    }
    const decodedTicket = {};
    for (const [key, value] of Object.entries(data.properties)) {
      decodedTicket[key] = convertFieldValueAvroToJson(value);
    }
    return decodedTicket;
  }, [isPreview, id, data]);
  return {
    data: ticket,
    refetch: invalidate,
    loading: loading && !data,
    error
  };
};